/**
 * @Author:
 * @Description:
 * @DateTime: Created in 2021-03-23 22:37:52
 */

import * as Vue from 'vue-tsx-support';
import { Component, Prop } from 'vue-property-decorator';
import 'vue-tsx-support/enable-check';
import Modal from 'src/types/iview/Modal';
import Button from 'src/types/iview/Button';
import { Toast } from 'src/util/toast';
import { modalFactory } from 'src/util/vueExtend';
import EnumOperates from 'src/enums/enumOperates';
import { Integer } from 'src/types/base';
import DeclareMalfunctionApi from './api/declareMalfunctionApi';
import { createNamespace } from 'src/util/bem';
import EnumMalfunctionAuditStatus from 'src/enums/enumMalfunctionAuditStatus';
import { DateTimeUtil } from 'src/util/dateTimeUtil';
import  DatePicker from 'src/types/iview/DatePicker';
import Input from 'src/types/iview/Input';
export namespace AuditMalfunctionVOI {
    export interface PropsI {
        operate: string;
        sheetNumber: string;
        id?: number;

        saveSuccess?(): void;

        cancel?(): void;
    }

    export interface FormDataI {
        id?: Integer;
        declare_type: string;
        operational_time: Integer;
        cause: string;
        sponsor_datetime: string;
        initiator: string;
        fault_site: { deviceName: string; components: string[] }[];
        status: number;
        refuse_cause: string;
        audit_time: string;
        auditor: string;
        submitter: string;
        nosubmit_cause: string;
        submit_datatime: string;
        operateStatus: number;
        timestamp:Integer;
    }
}

@Component
class AuditMalfunctionModal extends Vue.Component<AuditMalfunctionVOI.PropsI> {
    @Prop({
        type: Function,
    })
    cancel!: () => void;

    @Prop({
        type: Number,
    })
    id!: number;

    @Prop({
        type: String,
    })
    sheetNumber!: string;

    @Prop({
        type: String,
    })
    operate!: string;

    @Prop({
        type: Function,
    })
    saveSuccess!: () => void;

    visible: boolean = false;

    loading: boolean = false;

    formData: AuditMalfunctionVOI.FormDataI = {
        declare_type: '123',
        operational_time: null,
        cause: '',
        initiator: '',
        sponsor_datetime: '',
        fault_site: [],
        status: 0,
        refuse_cause: '',
        audit_time: '',
        auditor: '',
        submitter: '',
        submit_datatime: '',
        nosubmit_cause: '',
        operateStatus: this.operate === EnumOperates.Audit.getName() ? 1 : 0,
        timestamp: null,
    };
    rules: any = {};

    close() {
        this.cancel && this.cancel();
        this.closeModal();
    }

    closeModal() {
        this.visible = false;
        this.$emit('close', false);
    }

    async save() {
        if (
            this.operate === EnumOperates.Audit.getName() &&
            this.formData.operateStatus === EnumMalfunctionAuditStatus.审核不通过.getId() &&
            !this.formData.refuse_cause
        ) {
            return Toast.error('请填写审核不通过原因');
        }
        if (
            this.operate === EnumOperates.Submit.getName() &&
            this.formData.operateStatus === EnumMalfunctionAuditStatus.不提交.getId() &&
            !this.formData.nosubmit_cause
        ) {
            return Toast.error('请填写不提交原因');
        }
        let res;
        this.loading = true;
        switch (this.operate) {
            case EnumOperates.Audit.getName():
                debugger
                res = await DeclareMalfunctionApi.batchAudit({
                    ids: [this.id],
                    status: this.formData.operateStatus,
                    refuse_cause: this.formData.operateStatus === EnumMalfunctionAuditStatus.审核不通过.getId() ? this.formData.refuse_cause : '',
                    timestamp: DateTimeUtil.getSecondFromIviewDate(this.formData.timestamp)
                });
                break;
            case EnumOperates.Submit.getName():
                res = await DeclareMalfunctionApi.batchSubmit({
                    ids: [this.id],
                    status: this.formData.operateStatus,
                    nosubmit_cause: this.formData.operateStatus === EnumMalfunctionAuditStatus.不提交.getId() ? this.formData.nosubmit_cause : '',
                    timestamp: DateTimeUtil.getSecondFromIviewDate(this.formData.timestamp)
                });
                break;
        }

        this.loading = false;
        let { code } = res;
        if (code === 0) {
            Toast.success(this.operate + '成功');
            this.saveSuccess();
            this.closeModal();
        }
    }
    async mounted() {
        let { code, data } = await DeclareMalfunctionApi.searchDetail({ id: this.id });
        if (code === 0) {
            this.formData = {
                declare_type: data.declare_type,
                operational_time: data.operational_time,
                cause: data.cause,
                initiator: data.initiator,
                sponsor_datetime: data.sponsor_datetime,
                fault_site: data.fault_site.data.map(i => ({
                    deviceName: i.operational_site,
                    components: i.operational_equipment,
                })),
                status: data.status,
                refuse_cause: data.refuse_cause,
                audit_time: data.audit_time,
                auditor: data.auditor,
                submitter: data.submitter,
                submit_datatime: data.submit_datatime,
                nosubmit_cause: data.nosubmit_cause,
                operateStatus: this.formData.operateStatus
            };
        }
    }

    render(h) {
        return (
            <Modal
                title={'故障申报' + this.operate}
                width="800"
                v-model={this.visible}
                mask-closable={false}
                on-on-cancel={this.close}
                footer-hide={this.operate === EnumOperates.Detail.getName()}
            >
                <i-form ref="formValidate" labelWidth={140} class={createNamespace('detail-form')} model={this.formData}>
                    <form-item labelWidth={80} label="故障单号：" style="display: inline-block;width:40%">
                        {this.sheetNumber}
                    </form-item>
                    <form-item labelWidth={80} label="发起人" style="display: inline-block;width:30%">
                        {this.formData.initiator}
                    </form-item>
                    <form-item labelWidth={80} label="发起时间" style="display: inline-block;width:30%">
                        {this.formData.sponsor_datetime}
                    </form-item>
                    <form-item label="申报类型：" style="width:90%" class={createNamespace('mt15')}>
                        {this.formData.declare_type}
                    </form-item>
                    <form-item label="预计运维时长（h）：" style="width:90%">
                        {this.formData.operational_time}
                    </form-item>
                    <form-item label="原因：" style="display: inline-block;width:90%">
                        {this.formData.cause}
                    </form-item>
                    <form-item labelWidth={130} label="故障设备" class={createNamespace('mt15')} />
                    {this.formData.fault_site.map((i, index) => {
                        return (
                            <div>
                                <form-item label="故障站点：" style="width:90%">
                                    {i.deviceName}
                                </form-item>
                                {i.components.map(sub => (
                                    <form-item label="故障设备：" style="width:90%">
                                        {sub}
                                    </form-item>
                                ))}
                            </div>
                        );
                    })}
                    <div v-if={this.operate === EnumOperates.Detail.getName()}>
                        <form-item labelWidth={130} label="状态" class={createNamespace('mt15')} />
                        <form-item label="状态：" style="width:90%">
                            {EnumMalfunctionAuditStatus.findId(this.formData.status).getName()}
                        </form-item>
                        <form-item
                            label="提交人："
                            style="width:90%"
                            v-if={this.formData.status !== EnumMalfunctionAuditStatus.待提交.getId()}
                        >
                            {this.formData.submitter}
                        </form-item>
                        <form-item
                            label="提交时间："
                            style="width:90%"
                            v-if={this.formData.status !== EnumMalfunctionAuditStatus.待提交.getId()}
                        >
                            {this.formData.submit_datatime}
                        </form-item>
                        <form-item
                            label="不提交原因："
                            style="width:90%"
                            v-if={this.formData.status === EnumMalfunctionAuditStatus.不提交.getId()}
                        >
                            {this.formData.nosubmit_cause}
                        </form-item>
                        <form-item
                            label="审核人："
                            style="width:90%"
                            v-if={[EnumMalfunctionAuditStatus.审核通过.getId(), EnumMalfunctionAuditStatus.审核不通过.getId()].includes(
                                this.formData.status,
                            )}
                        >
                            {this.formData.auditor}
                        </form-item>
                        <form-item
                            label="审核时间："
                            style="width:90%"
                            v-if={[EnumMalfunctionAuditStatus.审核通过.getId(), EnumMalfunctionAuditStatus.审核不通过.getId()].includes(
                                this.formData.status,
                            )}
                        >
                            {this.formData.audit_time}
                        </form-item>
                        <form-item
                            label="不通过原因："
                            style="width:90%"
                            v-if={EnumMalfunctionAuditStatus.审核不通过.getId() == this.formData.status}
                        >
                            {this.formData.refuse_cause}
                        </form-item>
                    </div>
                    <div v-if={this.operate === EnumOperates.Audit.getName()}>
                        <form-item label="审核时间" prop="timestamp" required type="date" style="display: inline-block;width:45%">
                            <DatePicker editable placeholder="请选择" type="datetime" v-model={this.formData.timestamp} />
                        </form-item>
                        <form-item labelWidth={130} label="审核情况" class={createNamespace('mt15')} />
                        <form-item label="" labelWidth={70} style="display: inline-block;width:32%">
                            <radio-group v-model={this.formData.operateStatus}>
                                <radio label={EnumMalfunctionAuditStatus.审核通过.getId()}>
                                    {EnumMalfunctionAuditStatus.审核通过.getName()}
                                </radio>
                                <radio label={EnumMalfunctionAuditStatus.审核不通过.getId()}>
                                    {EnumMalfunctionAuditStatus.审核不通过.getName()}
                                </radio>
                            </radio-group>
                        </form-item>
                        <form-item
                            labelWidth={10}
                            v-if={this.formData.operateStatus === EnumMalfunctionAuditStatus.审核不通过.getId()}
                            label=""
                            style="display: inline-block;width:60%"
                            prop="refuse_cause"
                        >
                            <Input placeholder="请输入审核不通过原因" v-model={this.formData.refuse_cause} type="textarea" />
                        </form-item>
                    </div>
                    <div v-if={this.operate === EnumOperates.Submit.getName()}>
                        <form-item label="提交时间" prop="timestamp" required type="date" style="display: inline-block;width:45%">
                            <DatePicker editable placeholder="请选择" type="datetime" v-model={this.formData.timestamp} />
                        </form-item>
                        <form-item labelWidth={130} label="提交情况" class={createNamespace('mt15')} />
                        <form-item label="" labelWidth={70} style="display: inline-block;width:32%">
                            <radio-group v-model={this.formData.operateStatus}>
                                <radio label={0}>提交</radio>
                                <radio label={EnumMalfunctionAuditStatus.不提交.getId()}>
                                    {EnumMalfunctionAuditStatus.不提交.getName()}
                                </radio>
                            </radio-group>
                        </form-item>
                        <form-item
                            labelWidth={10}
                            v-if={this.formData.operateStatus === EnumMalfunctionAuditStatus.不提交.getId()}
                            label=""
                            style="display: inline-block;width:60%"
                            prop="refuse_cause"
                        >
                            <Input placeholder="请输入不提交原因" v-model={this.formData.nosubmit_cause} type="textarea" />
                        </form-item>
                    </div>
                </i-form>
                <div slot="footer">
                    <Button type="primary" ghost on-click={this.close}>
                        取消
                    </Button>
                    <Button type="primary" on-click={this.save} loading={this.loading}>
                        保存
                    </Button>
                </div>
            </Modal>
        );
    }
}

export default function alertAuditMalfunctionModal(operate: string, id: number, sheetNumber: string): Promise<boolean> {
    return new Promise((resolve, reject) => {
        modalFactory<AuditMalfunctionVOI.PropsI>(AuditMalfunctionModal)({
            id,
            operate,
            sheetNumber,
            saveSuccess() {
                resolve(true);
            },
            cancel() {
                resolve(false);
            },
        });
    });
}
